import { useFragmentFromStore } from '@smx-ui-model/hooks/use-fragment-from-store';
import React, { useEffect } from 'react';
import { useLazyLoadQuery } from 'react-relay';

interface WrapperOneLoaderProps {
    model: any;
    variables?: any;
    dataSourceRef: React.MutableRefObject<unknown>;
    fetchKey?: string | number;
}

export const WrapperOneLoaderQuery = ({ model, variables, dataSourceRef, fetchKey }: WrapperOneLoaderProps) => {
    const queryResult = useLazyLoadQuery<any>(
        // environment,
        model.queryOne!,
        variables,
        { fetchPolicy: 'network-only', fetchKey },
    );
    const dataFragment = useFragmentFromStore(queryResult[model.name]);

    useEffect(() => {
        dataSourceRef.current = dataFragment;
    }, [dataFragment]);

    return <></>;
};
